// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xt4u","content":"styles_content__1-X2U"};